// Holat filtrining IKKI maxsus qiymati va ularning serverdagi bayrog'i.
//
// ⚠️ NEGA BITTA JOYDA. Beshta ro'yxat (`lid`, `murojaat`, `xodim`,
// `jihoz`, `kampaniya`) bir xil qarorni yuritadi, lekin har biri o'z
// `*Api.ts` sida so'rov quradi. Satr nusxalari ajralib ketganda oqibat
// JIM bo'lardi: `'ALL'` o'rniga `'all'` yozilgan sahifada «Barcha
// holatlar» tanlovi serverga `includeClosed` ni umuman yubormay,
// yopilganlarni yashirin qoldirardi va ekranda hech qanday xato
// ko'rinmasdi.

import type { TableState } from './tableState'

/**
 * Holat tanlagichining ikki MAXSUS qiymati — ular holat EMAS.
 *
 * ⚠️ Bular alohida «yopilganlarni ko'rsatish» belgilagichining o'rnini
 * BOSMAYDI, aksincha uni keraksiz qiladi (ADR-033 §2): ro'yxat nimani
 * ko'rsatayotgani DOIM bitta tanlagichda yozilib turadi va ikkinchi,
 * yashirin boshqaruv qolmaydi.
 */
export const STATE_OPEN_ONLY = 'OPEN_ONLY'
export const STATE_ALL = 'ALL'

/**
 * Serverga {@code includeClosed=true} yuboriladigan YAGONA holat.
 *
 * ⚠️ Noma'lum qiymat (eski havola, qo'lda tahrirlangan URL) SUKUTGA
 * qaytadi. Teskarisi — «tanimadim, hammasini ko'rsataman» — standartni
 * jimgina buzardi va operator buni hech qayerdan bilmasdi.
 */
export function showsClosed(value: string | undefined): boolean {
  return value === STATE_ALL
}

/**
 * Jadval holatidagi yakka tanlov.
 *
 * ⚠️ Kalit YO'Q bo'lishi «filtr qo'yilmagan» degani EMAS — u sukut
 * ko'rinish, ya'ni yopilganlarsiz. Shuning uchun tanlagich bo'sh
 * qolmaydi va {@code allowClear} ham qo'yilmaydi.
 */
export function stateFilterValue(state: TableState, key: string): string {
  return state.filters[key]?.[0] ?? STATE_OPEN_ONLY
}
